var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger",staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.titulo))]),_c('h3',[_vm._v(_vm._s(_vm.rotaOrigem))])])
}
var staticRenderFns = []

export { render, staticRenderFns }